import { useMemo } from 'react';

import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { DivProps } from '../../types';

export const CardBody = ({ ref, ...props }: DivProps) => {
  const { className, children, ...other } = props;
  const { card } = useTheme();

  const cls = useMemo(() => twMerge(card.body, className), [card.body, className]);

  return (
    <div className={cls} ref={ref} {...other}>
      {children}
    </div>
  );
};
